import { styled } from '@cad-arc';
import { FederatedSearchEventPanelDexActivityList } from '../../../federated-search/federated-search-event-panel-dex-activity-list';
import { useGetEventIdAndTabNameFromParams } from '../../hooks/use-get-event-id-and-tab-name-from-params';
import { FrTabContentWrapper } from './styled';

const StyledFrTabContentWrapper = styled(FrTabContentWrapper)`
    flex-direction: column;
    overflow-y: auto;
`;

export function FrDexNextTab() {
    const { eventId } = useGetEventIdAndTabNameFromParams();
    return (
        <StyledFrTabContentWrapper>
            <FederatedSearchEventPanelDexActivityList eventId={eventId} />
        </StyledFrTabContentWrapper>
    );
}
